import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid } from '@mui/material';
import ProfileWidget from '../../shared/login/ProfileWidget';
import { useSelector } from 'react-redux';
import { selectOwnerDetails } from '../../pmui/owners/sagas/ownersSlice';

type Anchor = 'left';

interface PageHeaderProps {
  toggleMobileDrawer: (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => void;
  state: any;
  subTitle: string;
}

export default function PageHeader({ state, toggleMobileDrawer, subTitle }: PageHeaderProps) {
  const matchesMobile = useMediaQuery('(max-width:600px)');
  const isOnMobileScreen = useMediaQuery('(max-width:420px)');
  const matchesIpad = useMediaQuery('(max-width:1024px)');
  const ownerDetails = useSelector(selectOwnerDetails);
  const { FirstName, MiddleName, LastName } = ownerDetails;
  const pathName = window.location.pathname;

  const getTitleText = () => {
    let text = '';

    if (pathName.slice(7, pathName.length) === 'home') {
      text = 'Home';
    } else if (pathName.slice(7, pathName.length) === 'ledger') {
      text = 'Ledger';
    } else if (pathName.slice(7, pathName.length) === 'payments') {
      text = 'Payments';
    } else if (pathName.indexOf('documents') > -1) {
      text = 'Documents';
    } else if (pathName.indexOf('profilesettings') > -1) {
      text = 'Profile Settings';
    } else text = 'Inosio';

    return text;
  };

  const getOwnerNameText = () => {
    return `${FirstName}${MiddleName ? ' '.concat(MiddleName) : ''} ${LastName}`;
  };

  const getSubTitle = () => {
    return subTitle;
  };

  return (
    <Stack direction="row">
      {!(matchesMobile && state['left']) ? (
        <Stack direction="row">
          {matchesIpad ? (
            <IconButton
              edge="start"
              sx={{
                background: '#F1F0F5',
                height: '70px',
                borderRadius: '0px',
                ...(state['left'] && { display: 'none' }),
              }}
              onClick={toggleMobileDrawer('left', true)}
            >
              <MenuIcon sx={{ color: '#000', cursor: 'pointer' }}>{'left'}</MenuIcon>
            </IconButton>
          ) : (
            <></>
          )}
          {!isOnMobileScreen ? (
            <Stack gap="12px">
              <Typography
                noWrap
                id="mainTitle"
                sx={{
                  fontFamily: 'Work Sans',
                  lineHeight: '22px',
                  ...(state['left'] && { display: 'none' }),
                  // width: "400px"//TODO: temporary for mobile due to css issue
                }}
              >
                {getTitleText()}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Work Sans',
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#14142B',
                  lineHeight: '18px',
                }}
              >
                {getOwnerNameText()}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Work Sans',
                  fontSize: '18px',
                  fontWeight: '400',
                  color: '#14142B',
                  lineHeight: '18px',
                }}
              >
                {getSubTitle()}
              </Typography>
            </Stack>
          ) : (
            <Stack gap="22px">
              <Typography
                sx={{
                  fontFamily: 'Work Sans',
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#14142B',
                  lineHeight: '18px',
                }}
              >
                {getOwnerNameText()}
              </Typography>
            </Stack>
          )}
        </Stack>
      ) : (
        <></>
      )}

      <Grid sx={{ position: 'absolute', top: 0, right: 0, padding: 2 }}>
        {!(matchesMobile && state['left']) ? (
          <>
            <ProfileWidget />
          </>
        ) : (
          <></>
        )}
      </Grid>
    </Stack>
  );
}
